module.exports = __webpack_public_path__ + "a113d19ed31dc4033beb40c04a25e029.svg";